export { Microfluidics }

class Microfluidics {

  static alpha({ width, height }: {
    width: number
    height: number
  }): number {
    return 12 * (1 / (1 - (192 * height /  (Math.pow(Math.PI, 5) * width)) * Math.tanh(Math.PI * width / (2 * height))))
  }

  static resistance({ width, height, length, viscosity }: {
    width: number,
    height: number,
    length: number,
    viscosity: number
  }): number {
    const alpha = Microfluidics.alpha({ width, height })
    const resistance = (alpha * viscosity * length) / (width * Math.pow(height, 3))
    return resistance
  }

  static resistanceMicro({ width, height, length, viscosity }: {
    width: number,
    height: number,
    length: number,
    viscosity: number
  }): number {
    return Microfluidics.resistance({
      width: width * 1e-6,
      height: height * 1e-6,
      length: length * 1e-6,
      viscosity
    })
  }

  static lengthFromResistance({ width, height, resistance, viscosity }: {
    width: number,
    height: number,
    resistance: number,
    viscosity: number
  }): number {
    const alpha = Microfluidics.alpha({ width, height })
    const length = (width * Math.pow(height, 3) * resistance) / (alpha * viscosity)
    return length
  }

  static lengthFromResistanceMicro({ width, height, resistance, viscosity }: {
    width: number,
    height: number,
    resistance: number,
    viscosity: number
  }): number {
    return Microfluidics.lengthFromResistance({
      width: width * 1e-6,
      height: height * 1e-6,
      resistance,
      viscosity
    }) * 1e6
  }
}
